export default __webpack_public_path__ + "static/media/testbanner.6136aaa0.jpg";